export const TIMEZONE_MAP = {
"(UTC-12:00) International Date Line West": "Etc/GMT+12",
"(UTC-11:00) Coordinated Universal Time-11": "Etc/GMT+11",
"(UTC-10:00) Aleutian Islands": "America/Adak",
"(UTC-10:00) Hawaii": "Pacific/Honolulu",
"(UTC-09:30) Marquesas Islands": "Pacific/Marquesas",
"(UTC-09:00) Alaska": "America/Anchorage",
"(UTC-08:00) Pacific Time (US & Canada)": "America/Los_Angeles",
"(UTC-07:00) Arizona": "America/Phoenix",
"(UTC-07:00) Mountain Time (US & Canada)": "America/Denver",
"(UTC-06:00) Central Time (US & Canada)": "America/Chicago",
"(UTC-05:00) Eastern Time (US & Canada)": "US/Eastern",
"(UTC-04:00) Atlantic Time (Canada)": "America/Halifax",
"(UTC-03:30) Newfoundland": "America/St_Johns",
"(UTC-03:00) Brasilia": "America/Sao_Paulo",
"(UTC-01:00) Azores": "Atlantic/Azores",
"(UTC) Coordinated Universal Time": "UTC",
"(UTC+00:00) Dublin, Edinburgh, Lisbon, London": "Europe/London",
"(UTC+01:00) Amsterdam, Berlin, Rome, Stockholm, Vienna": "Europe/Berlin",
"(UTC+01:00) Brussels, Copenhagen, Madrid, Paris": "Europe/Paris",
"(UTC+02:00) Athens, Bucharest": "Europe/Athens",
"(UTC+02:00) Cairo": "Africa/Cairo",
"(UTC+02:00) Jerusalem": "Asia/Jerusalem",
"(UTC+03:00) Moscow": "Europe/Moscow",
"(UTC+03:00) Nairobi": "Africa/Nairobi",
"(UTC+03:30) Tehran": "Asia/Tehran",
"(UTC+04:00) Abu Dhabi, Muscat": "Asia/Dubai",
"(UTC+04:30) Kabul": "Asia/Kabul",
"(UTC+05:00) Islamabad, Karachi": "Asia/Karachi",
"(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi": "Asia/Kolkata",
"(UTC+05:45) Kathmandu": "Asia/Kathmandu",
"(UTC+06:00) Dhaka": "Asia/Dhaka",
"(UTC+06:30) Yangon": "Asia/Yangon",
"(UTC+07:00) Bangkok, Hanoi, Jakarta": "Asia/Bangkok",
"(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi": "Asia/Shanghai",
"(UTC+08:00) Kuala Lumpur, Singapore": "Asia/Singapore",
"(UTC+09:00) Osaka, Sapporo, Tokyo": "Asia/Tokyo",
"(UTC+09:00) Seoul": "Asia/Seoul",
"(UTC+09:30) Adelaide": "Australia/Adelaide",
"(UTC+10:00) Canberra, Melbourne, Sydney": "Australia/Sydney",
"(UTC+10:00) Brisbane": "Australia/Brisbane",
"(UTC+11:00) Solomon Is., New Caledonia": "Pacific/Guadalcanal",
"(UTC+12:00) Auckland, Wellington": "Pacific/Auckland",
"(UTC+12:00) Fiji": "Pacific/Fiji",
"(UTC+13:00) Samoa": "Pacific/Apia",
"(UTC+14:00) Kiritimati Island": "Pacific/Kiritimati"
};
